import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "file-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "title",
      draggable: "true",
      onDragstart: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDragStart && _ctx.onDragStart(...args)))
    }, _toDisplayString(_ctx.title), 33)
  ]))
}